import { ChangeEvent } from 'react';
import Button from '../buttons/baseButton';

const uploadCompleteMessage = (templateFileName: string) => `Upload complete: ${templateFileName}`;

interface UploadTemplateProps {
  uploadFile: (file: File) => void;
  isUploading: boolean;
  uploadedFileName: string | null;
  error: string | null;
  reset: () => void;
}

export default function UploadTemplate({
  uploadFile, isUploading, uploadedFileName, error, reset,
}: Readonly<UploadTemplateProps>) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) uploadFile(file);
  };

  return (
    <div className="flex flex-col gap-2 max-w-fit">
      <input
        type="file"
        accept=".docx"
        onChange={handleChange}
        disabled={isUploading}
        className="p-1 rounded-md border border-pipgrey-light hover:bg-pipgrey-light hover:border-pipgrey-md cursor-pointer"
      />

      {isUploading && (
        <>
          <span className="text-sm">Uploading...</span>
          <Button
            id="upload-cancel-button"
            onClick={reset}
            label="Cancel Upload"
            className="text-xs text-secondary underline mt-1 self-start"
            isDisabled={false}
          />
        </>
      )}

      {uploadedFileName && !isUploading && (
        <span className="text-sm text-primary">
          {uploadCompleteMessage(uploadedFileName)}
        </span>
      )}

      {error && <span className="text-sm text-piptext-error">{error}</span>}
    </div>
  );
}
